import { render, staticRenderFns } from "./PageAFQTypeformAllianz.vue?vue&type=template&id=19afbac8"
import script from "./PageAFQTypeformAllianz.vue?vue&type=script&lang=js"
export * from "./PageAFQTypeformAllianz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports